shadow$provide[533] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Axis:{enumerable:true, get:function() {
  return Axis;
}}, Data:{enumerable:true, get:function() {
  return Data;
}}, Ease:{enumerable:true, get:function() {
  return Ease;
}}, GLSL:{enumerable:true, get:function() {
  return GLSL;
}}, JS:{enumerable:true, get:function() {
  return JS;
}}, Pretty:{enumerable:true, get:function() {
  return Pretty;
}}, Three:{enumerable:true, get:function() {
  return Three;
}}, Ticks:{enumerable:true, get:function() {
  return Ticks;
}}, VDOM:{enumerable:true, get:function() {
  return VDOM;
}}});
var axis = require("./axis.js");
var data = require("./data.js");
var ease = require("./ease.js");
var glsl = require("./glsl.js");
var js = require("./js.js");
var pretty = require("./pretty.js");
var three = require("./three.js");
var ticks = require("./ticks.js");
var vdom = require("./vdom.js");
const Axis = axis;
const Data = data;
const Ease = ease;
const GLSL = glsl;
const JS = js;
const Pretty = pretty;
const Three = three;
const Ticks = ticks;
const VDOM = vdom;

};